import {
  DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_REQUEST,
  DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_SUCCESS,
  DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_FAILURE,
  DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_RESET,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
  fileLink: null,
}

const downloadBazaarEnquiryExcelReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
        fileLink: null,
      }

    case DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "",
        fileLink: action.payload.fileLink,
      }

    case DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
        fileLink: null,
      }

    case DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default downloadBazaarEnquiryExcelReducer
